import React from 'react';
import InitialMotion from '../../marketingRendering/InitialMotion';

import SectionHeader from './SectionHeader';

function ProductTileGrid({
  id,
  label,
  title,
  description,
  tiles,
  alternate = false,
}) {
  return (
    <section className={`products${alternate ? ' section-alt' : ''}`} id={id}>
      <div className="container">
        <SectionHeader label={label} title={title} description={description} />

        <div className="tile-grid">
          {tiles.map((tile) => (
            <InitialMotion motionKey={`tile-${tile.title}`} className="tile" data-aos="fade-up" key={tile.title}>
              <div className={`tile-icon ${tile.tone}`}>
                <span className="material-symbols-outlined">{tile.icon}</span>
              </div>
              <h3>{tile.title}</h3>
              <p>{tile.body}</p>
              {tile.href && (
                <a href={tile.href} className="text-link">
                  {tile.ctaLabel || 'Learn more'}
                </a>
              )}
            </InitialMotion>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductTileGrid;
